// PERSISTENT-SCREENS: a screen waiting on a person stays open until its request expires (30 min by
// default, the company's setting; Extend adds 15 min). The countdown shows on the chat card, the
// inbox item and the Live toolbar.
import { cn } from "@companyos/ui";
import { TimerIcon } from "lucide-react";
import { useEffect, useState } from "react";

/** "12:04 left" / "1 h 05 left" until `iso` (null once past). */
export function timeLeft(iso: string, now: number): string | null {
  const s = Math.floor((new Date(iso).getTime() - now) / 1000);
  if (s <= 0) return null;
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return h > 0
    ? `${h} h ${String(m).padStart(2, "0")} left`
    : `${m}:${String(sec).padStart(2, "0")} left`;
}

/** A ticking countdown to `expiresAt` (warning tone in the last 5 minutes). */
export function AskCountdown({ expiresAt }: { expiresAt: string }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const left = timeLeft(expiresAt, now);
  const low = new Date(expiresAt).getTime() - now < 5 * 60_000;
  return (
    <span
      data-slot="screen-ask-countdown"
      className={cn(
        "inline-flex shrink-0 items-center gap-1 text-xs tabular-nums whitespace-nowrap",
        low ? "text-warning-text" : "text-muted-foreground",
      )}
    >
      <TimerIcon aria-hidden="true" className="size-3" />
      {left ?? "Expiring…"}
    </span>
  );
}
